import { render } from "./AccountWriteOffTable.vue?vue&type=template&id=5e6460d4"
import script from "./AccountWriteOffTable.vue?vue&type=script&lang=js"
export * from "./AccountWriteOffTable.vue?vue&type=script&lang=js"

import "./AccountWriteOffTable.vue?vue&type=style&index=0&id=5e6460d4&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__